import axios from 'axios';
import moment from 'moment';
import numeral from 'numeral';
// @ts-ignore
import extras from 'virtual:i18n-extras';
import { Locale } from 'vue-i18n';
// @ts-ignore
import config from '@/../i18n.config';
import i18n, { DEFAULT_LOCALE } from '../i18n';

class LocaleService {
  init(): Promise<void> {
    return this.update(this.findMatchingBrowserLocale());
  }

  async update(locale: Locale): Promise<void> {
    await Promise.all([this.load(locale), this.loadExtras(locale)]);
    this.apply(locale);
  }

  private findMatchingBrowserLocale(): Locale {
    for (const locale of navigator.languages) {
      if (config.locales.includes(locale)) return locale;
      const language = new Intl.Locale(locale).language;
      if (config.locales.includes(language)) return language;
    }
    return DEFAULT_LOCALE;
  }

  private async load(locale: Locale): Promise<void> {
    if (locale in i18n.global.messages) return;
    const messages = await import(`../../shared/assets/lang/${locale}.json`);
    i18n.global.setLocaleMessage(locale, messages);
  }

  private apply(locale: Locale): void {
    if (i18n.global.locale.value === locale) return;
    i18n.global.locale.value = locale;
    axios.defaults.headers.common['Accept-Language'] = locale;
    document.querySelector('html')?.setAttribute('lang', locale);
    moment.locale(config.libraries.moment.map(locale));
    numeral.locale(config.libraries.numeral.map(locale));
  }

  private async loadExtras(locale: Locale): Promise<void> {
    await Promise.allSettled(extras[locale]());
  }
}

export default new LocaleService();